import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Pharmacy } from 'src/app/Models/pharmacy.model';
import { PharmacylistService } from 'src/app/services/pharmacylist.service';

@Component({
  selector: 'app-pharmacylist',
  templateUrl: './pharmacylist.component.html',
  styleUrls: ['./pharmacylist.component.css'],
})
export class PharmacylistComponent implements OnInit {
  displayedColumns: string[] = [
    'PharmacyName',
    'PhoneNumber',
    'Email',
    'PharmacyAddress',
    'Status',
    'Update',
    'Delete',
  ];
  pharmacyList: Pharmacy[] = [];
  dataSource: MatTableDataSource<any>;

  selectedFile: File;

  constructor(private PharmacyService: PharmacylistService) {}

  ngOnInit(): void {
    this.getPharmacy();
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  // }

  getPharmacy() {
    this.PharmacyService.getPharmacys().subscribe((res) => {
      // this.PharmacyList = res;

      this.dataSource = new MatTableDataSource(res);
      this.dataSource.paginator = this.paginator;
    });
  }

  tabChanged(event: MatTabChangeEvent): void {
    if (event.index === 0) {
      this.getPharmacy();
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onFileSelected(event) {
    this.selectedFile = event.target.files[0];
  }

  uploadFile() {
    const fileReader = new FileReader();
    fileReader.readAsText(this.selectedFile, 'UTF-8');
    fileReader.onload = () => {
      const fileContent = fileReader.result;
      try {
        const data = JSON.parse(fileContent as string);

        // Validate the data structure
        if (!Array.isArray(data.Pharmacies)) {
          alert('Invalid data structure');
        }
        data.Pharmacies.forEach((ph) => {
          if (typeof ph.PharmacyName !== 'string') {
            alert('Invalid data structure');
          }
          // Add more checks as necessary...
        });

        this.PharmacyService.UploadJsonPharmacyData(data).subscribe(
          (res) => {
            alert('Upload With success');
            this.getPharmacy();
          },
          (err) => {
            alert('Error uploading the data');
          }
        );
        // this.http.post('https://your-api-url.com/upload', data)
        // .subscribe(
        //     response => console.log(response),
        //     error => console.log(error)
        // );
      } catch (error) {
        console.error('Invalid JSON format:', error);
      }
    };
    fileReader.onerror = (error) => console.log(error);
  }

  deletePharmacy(id) {
    this.PharmacyService.deletePharmacy(id).subscribe(
      (res) => {
        alert('Pharmacy Delete with success');
        this.getPharmacy();
      },
      (err) => {
        alert('Unsuccessful');
      }
    );
  }
}
